/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Template_CondensedInputs */



/**
* | output |
* | --- |
* | "Condensed" |
*
* @param {Ccsl_Export_Template_CondensedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_template_condensed = /** @type {((inputs?: Ccsl_Export_Template_CondensedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Template_CondensedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Condense")
	if (locale === "de") return /** @type {LocalizedString} */ ("Kondensiert")
	if (locale === "it") return /** @type {LocalizedString} */ ("Condensato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сокращенный")
	if (locale === "es") return /** @type {LocalizedString} */ ("Condensado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("浓缩版")
	if (locale === "ja") return /** @type {LocalizedString} */ ("要約")
	if (locale === "hi") return /** @type {LocalizedString} */ ("संघनित")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Condensado")
	return /** @type {LocalizedString} */ ("Condensed")
});